module.exports = __webpack_public_path__ + "img/close.c07ee314.png";